import * as React from 'react';

export type Props = React.PropsWithChildren;

function Area(props: Props) {
  const { children } = props;
  return (
    <div style={{ border: '1px solid', borderRadius: '4px', width: '100%', height: '300px', marginBottom: '1rem' }}>
      {children}
    </div>
  );
}

export default React.memo(Area);
